import { Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { colors } from '../../theme/theme';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h1" sx={{ fontSize: '6rem', mb: 2 }}>☕</Typography>
      <Typography variant="h3" sx={{ fontWeight: 700, mb: 1, color: colors.primary.main }}>404</Typography>
      <Typography variant="h5" sx={{ mb: 1 }}>{t('pages.not_found.title')}</Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>This table doesn't exist. Let's find you a better one.</Typography>
      <Button variant="contained" size="large" onClick={() => navigate('/')}>Back to Home</Button>
    </Container>
  );
}
